'use strict';

/*
    WEBSITE TRAVELER REDESIGN
    created on: 01/09/2023
    Authors: ISC. Oswaldo Álvarez Juárez
    Email: oswaldo.aj29@outlook.com

*/

/*===============================================
VARIABLES GENERALES
=================================================*/
$(document).ready(function(){
    StartEvents();
});

//FUNCTION THAT EXECUTE METHODS
function StartEvents(){
    carouselSwiperAbout();
}

//FUNCTIONS
/**
 * Función para hacer funcionar nuestro carousel con swiper
 */
function carouselSwiperAbout(){
    let swiper = new Swiper('.mySwiperAbout', {
        slidesPerView: 1,
        spaceBetween: 70,
        grabCursor: true,
        loop: true,
        breakpoints:{
            991:{
                slidesPerView: 2
            }
        }
    })
}